import React from 'react';
import { Link } from 'react-router-dom'
import './HomeFooterStyle.scss';

const HomeFooterView = (props) => {
    return (
        <>
            <footer id="cc-footer">
                <div className="cc-footer_wrapper">
                    <div className="row">
                        <div className="col-md-12 col-lg-4">
                            <div className="footer-left">
                                <p>© 2020 Carerconnect. All Rights Reserved</p>
                                <p>Version Number:<i>v1.13.02.21</i></p>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-2">
                            <div className="footer-center">
                                <h6 style={{color:'#767979'}}>CUSTOMER SERVICE</h6>
                                <ul className="footer-links">
                                    <li><Link href="/pages/about-us">About Us</Link></li>
                                    <li><Link href="/pages/how-to-post-jobs">How To Post Jobs</Link></li>
                                    <li><Link href="/pages/how-to-recruit-talent">How To Recruit Talent</Link></li>
                                    <li><Link href="/pages/how-to-find-jobs">How To Find Jobs</Link></li>
                                    <li><Link href="/pages/why-work-for-us">Why Work For Us</Link></li>
                                    <li><Link href="/pages/our-popular-jobs">Our Popular Jobs</Link></li>
                                    <li><Link href="/pages/references">References</Link></li>
                                    <li><Link href="/pages/testimonials">Testimonials</Link></li>
                                </ul>
                            </div>

                        </div>
                        <div className="col-md-12 col-lg-2">
                            <div className="footer-center">
                                <h6 style={{color:'#767979'}}>SITE RESOURCES</h6>
                                <ul className="footer-links">
                                    <li><Link href="/pages/privacy-policy">Privacy Policy</Link></li>
                                    <li><Link href="/pages/terms-of-use">Terms of Use</Link></li>
                                    <li><Link href="/pages/gdpr">GDPR</Link></li>
                                    <li><Link href="/pages/site-map">Site Map</Link></li>
                                </ul>
                            </div>

                        </div>
                        <div className="col-md-12 col-lg-2">
                            <div className="footer-center">
                                <h6 style={{color:'#767979'}}>BUSINESS SOLUTIONS</h6>
                                <ul className="footer-links">
                                    <li><Link href="/user/registration">Register</Link></li>
                                    <li><Link href="/login">Login</Link></li>
                                    <li><Link href="/job-post">Post A Job</Link></li>
                                    <li><a href="#cc-top_talent">Recruit Talent</a></li>
                                    <li><Link href="/find-jobs">Find A Job</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-12 col-lg-2">
                            <div className="footer-right">
                                <ul className="footer-social-links">
                                    <li><Link href="#"><i className="fa fa-facebook" aria-hidden="true"></i></Link></li>
                                    <li><Link href="#"><i className="fa fa-twitter" aria-hidden="true"></i></Link></li>
                                    <li><Link href="#"><i className="fa fa-linkedin" aria-hidden="true"></i></Link></li>
                                    <li><Link href="#"><i className="fa fa-youtube-play" aria-hidden="true"></i></Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default HomeFooterView;